import { useState, useEffect, useRef } from "react";
import "react-pdf/dist/esm/Page/TextLayer.css";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import { observer, inject } from "mobx-react";
import { useTranslation } from "react-i18next";
import { useTheme } from "styled-components";
import CalendarImg from "../assets/img/calendar.svg";
import MessageImg from "../assets/img/messages.svg";
import CloseImg from "../assets/img/close_icon.svg";
import {
  InnerBox,
  StatusLabel,
  TextSpeech,
  BoxHeader,
  List,
  ListItem,
  ScrollDiv,
  Item,
  getStatusColor,
  getStatusTextColor,
} from "./Common";
import { Modal, Text } from "../UI";
import $ from "jquery";
import { format } from "date-fns";
import { Role } from "../stores/userStore";
import { BorderButton } from "../UI/Button/Button";
import CalendlyWidget from "../UI/Calendly/Calendly";
import { useMobile } from "../utils/mobile";
import RepairMessages from "./RepairMessages";
import { useNavigate } from "react-router-dom";

const RepairPagesMessageContent = ({
  repairPage,
  repairPagesStore,
  userStore,
  tenantsStore,
  bedek
}) => {
  const { t, i18n } = useTranslation("applies");
  const theme = useTheme();
  const [showCalendlyModal, setShowCalendlyModal] = useState(false);
  const [showMessagesModal, setShowMessagesModal] = useState(false);
  const isMobile = useMobile();
  const navigate = useNavigate();

  const messageMenuRef = useRef(null);
  const isRtl = i18n.dir() === "rtl";

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (messageMenuRef.current && !messageMenuRef.current.contains(event.target)) {
        setShowMessagesModal(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [messageMenuRef]);


  const handleNoteSelected = (repairPage) => {
    if (userStore.userDetails.role === Role.Tenant) {
      const body = {
        MAINCUST: tenantsStore.selectedSiteSpace.CUST,
        MAINENV: tenantsStore.selectedSiteSpace?.DNAME,
        CUST: tenantsStore.selectedSiteSpace.CUST,
        DNAME: tenantsStore.selectedContract?.DNAME,
        ENV: tenantsStore.selectedContract?.DNAME,
        REPAIRNAME: repairPage.REPAIRNAME,

        data: {
          WASREADFLAG: "Y",
        },
      };
      repairPagesStore.updateRepairPage(body);
    }
  };

  useEffect(() => {
    handleNoteSelected(repairPage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [repairPage]);

  const getDescription = (description) => {
    var descriptionWithNoStyle = description?.replace(
      /<style.*?<\/style>/g,
      ""
    );
    const element = $(descriptionWithNoStyle);
    var longDescription = element.text();
    return longDescription;
  };

  const renderFilesList = (list) => (
    <List style={{ gap: 0 }}>
      {list?.map(function (item, index) {
        return <ListItem key={index} backgroundImage={item.EXTFILENAME} />;
      })}
    </List>
  );

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
        }}
      >
        <BoxHeader>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              width: "100%",
              marginTop: 20,
              alignItems: "center",
              justifyContent: "space-between",
            }} >
            <Text.H5 color={theme.color.gray90} style={{ textAlign: "start" }}>
              {`${t("bedek")} /
              ${t("inquiry_number", {
                num: repairPage.REPAIRNAME,
              })}`}

            </Text.H5>

            {showMessagesModal && <div>


              <div style={{
                backgroundColor: theme.color.primary,
                borderRadius: 50,
                width: 30,
                height: 30,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}>
                <img
                  src={CloseImg}
                  alt="close"
                />
              </div>


            </div>
            }
            {!showMessagesModal && <div
              style={{ display: "flex", flexDirection: "row-reverse", gap: 10, alignItems: "center", marginInlineStart: 20 }}>
              {repairPage.ZCOB_TENANTCONV_SUBFORM?.filter(m => m.ISNEW === "Y" && m.ISTENANT !== "Y")?.length > 0 && <div
                style={{
                  position: "relative",
                  backgroundColor: theme.color.primary,
                  border: `1px solid ${theme.color.white}`,
                  borderRadius: 50,
                  width: 18,
                  height: 20,
                  top: -7,
                  right: isRtl ? -102 : +107,
                  zIndex: 999,

                }}>
                {<div style={{ display: "flex", alignItems: "center", justifyContent: "center", }}>
                  <Text color={theme.color.white} size={10}>
                    {repairPage.ZCOB_TENANTCONV_SUBFORM?.filter(m => m.ISNEW === "Y" && m.ISTENANT !== "Y")?.length}
                  </Text>
                </div>}
              </div>}

              {!showMessagesModal && <BorderButton
                imgSrc={MessageImg}
                text={t("messages")}
                onClick={() => {
                  !isMobile ?
                    setShowMessagesModal(true) :
                    bedek ? navigate("/bedek/repair_messages") :
                      navigate("/tenant/repair_messages");
                }}
              />}
            </div>}
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              gap: 10,
              marginTop: 20,
              alignItems: "center",
            }}
          >
            <StatusLabel
              color={getStatusTextColor(repairPage, theme)}
              backgroundColor={getStatusColor(repairPage, theme)}
              borderColor={
                getStatusColor(repairPage, theme) === "rgb(255,255,255)"
                  ? theme.color.black
                  : null
              }
            >
              {repairPage?.STATDES}
            </StatusLabel>
            <Text.SR color={theme.color.gray90} style={{ textAlign: "start" }}>
              {format(
                repairPage.CURDATE !== undefined
                  ? new Date(repairPage.CURDATE)
                  : new Date(),
                "dd/MM/yyyy"
              )}
            </Text.SR>
            /
            <Text.SR color={theme.color.gray90} style={{ textAlign: "start" }}>
              {t("inquirer_name", {
                name: repairPage.APPLICANTNAME,
              })}
            </Text.SR>
          </div>
        </BoxHeader >
        <div
          style={{
            display: "flex",
            width: "100%",
            flex: 1,
            justifyContent: "space-between",
            alignItems: "center",
            paddingInline: 20,
          }}
        >
          <Text.BM
            color={theme.color.navy}
            style={{
              textAlign: "start",
              borderBottom: "1px solid",
              borderColor: theme.color.gray30,
              padding: `5px 20px`,
              margin: 20,
              marginBottom: 0,
              width: "100%",
            }}
          >
            {t("subjects_repair_title")}
          </Text.BM>
          {repairPage.EXAMINERCALENDLYLINK &&
            ((repairPage.ZCOB_CALENDLYEVISIT &&
              repairPagesStore.statuses?.find((s) => s.INITAPPFLAG === "Y")
                .STATDES === repairPage.STATDES) ||
              (repairPage.ZCOB_CALENDLYEFIX &&
                repairPagesStore.statuses?.find((s) => s.CHECKEDFLAG === "Y")
                  .STATDES === repairPage.STATDES)) && (
              <BorderButton
                imgSrc={CalendarImg}
                text={t("visit_schedule")}
                onClick={() => {
                  setShowCalendlyModal(true);
                }}
              />
            )}
        </div>
        <ScrollDiv maxHeight={isMobile ? "61vh" : "90vh"}>
          {repairPage.ZCOB_DEFECTSLIST_SUBFORM?.map((defect, index) => (
            <div
              key={index}
              style={{
                borderBottom: "1px dotted",
                borderColor: theme.color.gray50,
                padding: `5px 20px`,
                margin: isMobile ? 0 : 20,
                marginTop: 0,
              }}
            >
              <InnerBox>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "start",
                    flexDirection: "row",
                    width: "100%",
                    flexWrap: "wrap",
                  }}
                >
                  <Item style={{ flexBasis: isMobile ? "50%" : "auto" }}>
                    <Text.SR
                      color={theme.color.gray70}
                      style={{
                        textAlign: "start",
                        paddingTop: 10,
                      }}
                    >
                      {t("KLINE")}
                    </Text.SR>
                    <Text.SM
                      color={theme.color.navy}
                      style={{ textAlign: "start" }}
                    >
                      {defect.KLINE}
                    </Text.SM>
                  </Item>
                  <Item style={{ flexBasis: isMobile ? "50%" : "auto" }}>
                    <Text.SM
                      color={theme.color.gray70}
                      style={{
                        textAlign: "start",
                        paddingTop: 10,
                      }}
                    >
                      {t("SITEAREADES")}
                    </Text.SM>
                    <Text.SM
                      color={theme.color.navy}
                      style={{ textAlign: "start" }}
                    >
                      {defect.SITEAREADES}
                    </Text.SM>
                  </Item>
                  <Item style={{ flexBasis: isMobile ? "50%" : "auto" }}>
                    <Text.SR
                      color={theme.color.gray70}
                      style={{
                        textAlign: "start",
                        paddingTop: 10,
                      }}
                    >
                      {t("LOCATIONDES")}
                    </Text.SR>
                    <Text.SM
                      color={theme.color.navy}
                      style={{
                        textAlign: "start",
                      }}
                    >
                      {defect.LOCATIONDES}
                    </Text.SM>
                  </Item>
                  <Item style={{ flexBasis: isMobile ? "50%" : "auto" }}>
                    <Text.SR
                      color={theme.color.gray70}
                      style={{
                        textAlign: "start",
                        paddingTop: 10,
                      }}
                    >
                      {t("CHKPERIODTYPEDES")}
                    </Text.SR>
                    <Text.SM
                      color={theme.color.navy}
                      style={{ textAlign: "start" }}
                    >
                      {defect.CHKPERIODTYPEDES}
                    </Text.SM>
                  </Item>
                  <Item style={{ flexBasis: isMobile ? "50%" : "auto" }}>
                    <Text.SR
                      color={theme.color.gray70}
                      style={{
                        textAlign: "start",
                        paddingTop: 10,
                      }}
                    >
                      {t("STATDES")}
                    </Text.SR>
                    <StatusLabel
                      color={
                        getStatusColor(defect, theme) !== theme.color.white
                          ? theme.color.white
                          : theme.color.navy
                      }
                      backgroundColor={getStatusColor(defect, theme)}
                      borderColor={
                        getStatusColor(defect, theme) === theme.color.white &&
                          defect?.STATDES
                          ? theme.color.palePrimary
                          : null
                      }
                    >
                      {defect?.STATDES}
                    </StatusLabel>
                  </Item>
                  <Item style={{ flexBasis: isMobile ? "50%" : "auto" }}>
                    <Text.SR
                      color={theme.color.gray70}
                      style={{
                        textAlign: "start",
                        paddingTop: 10,
                      }}
                    >
                      {t("SUPDES")}
                    </Text.SR>
                    <Text.SM
                      color={theme.color.navy}
                      style={{ textAlign: "start" }}
                    >
                      {defect.SUPDES}
                    </Text.SM>
                  </Item>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: isMobile ? "column" : "row",
                    gap: 20,
                    width: "100%",
                    paddingTop: 10,
                    justifyContent: "space-between",
                  }}
                >
                  <div style={{ width: isMobile ? "100%" : "50%" }}>
                    <Text.SR
                      color={theme.color.gray70}
                      style={{ textAlign: "start", paddingTop: 10 }}
                    >
                      {t("desc_title")}
                    </Text.SR>
                    <div>
                      <Text.SM
                        color={theme.color.navy}
                        style={{ textAlign: "start" }}
                      >
                        {!!defect.DEFECTDES && `${defect.DEFECTDES}`}
                        {!!defect.ZCOB_DEFECTSLISTTEXT_SUBFORM?.TEXT &&
                          `${getDescription(
                            defect.ZCOB_DEFECTSLISTTEXT_SUBFORM?.TEXT
                          )}`}
                      </Text.SM>
                    </div>
                  </div>
                  <div>
                    <Text.SR
                      color={theme.color.gray70}
                      style={{ textAlign: "start" }}
                    >
                      {t("files_title")}
                    </Text.SR>
                    {renderFilesList(
                      [{ EXTFILENAME: defect.EXTFILENAME }].concat(
                        defect.ZCOB_DEFECTSLISTPIC_SUBFORM
                      )
                    )}
                  </div>
                </div>
              </InnerBox>
              {defect.ZCOB_DEFECTSLISTRMK_SUBFORM && (
                <InnerBox>
                  <Text.H5
                    color={theme.color.gray70}
                    style={{ textAlign: "start" }}
                  >
                    {t("response_repair_title")}
                  </Text.H5>
                  <TextSpeech style={{ width: "96%" }}>
                    <Text.SR
                      color={theme.color.gray90}
                      style={{ textAlign: "start", boxShadow: true }}
                    >
                      {!!defect.REMARK && `${defect.REMARK}`}
                      {!!defect.ZCOB_DEFECTSLISTRMK_SUBFORM?.TEXT &&
                        `${getDescription(
                          defect.ZCOB_DEFECTSLISTRMK_SUBFORM?.TEXT
                        )}`}
                    </Text.SR>
                  </TextSpeech>
                </InnerBox>
              )}
            </div>
          ))}
        </ScrollDiv>
        {
          showCalendlyModal && (
            <Modal
              onClose={() => {
                setShowCalendlyModal(false);
              }}
            >
              <CalendlyWidget
                repairPage={repairPage}
                url={
                  `${repairPage.EXAMINERCALENDLYLINK}/${repairPage.ZCOB_CALENDLYEVISIT &&
                    repairPagesStore.statuses?.find((s) => s.INITAPPFLAG === "Y")
                      .STATDES === repairPage.STATDES
                    ? repairPage.ZCOB_CALENDLYEVISIT
                    : repairPage.ZCOB_CALENDLYEFIX
                  }?hide_event_type_details=1&hide_gdpr_banner=1&email=${userStore.userDetails.USERNAME
                  } ` +
                  `&name=${userStore.userDetails.NAME}&a1=${repairPage.ADDRESS}&a2=${userStore.userDetails.CELLPHONE}`
                }
              />
            </Modal>
          )
        }

        {
          showMessagesModal && !isMobile && (
            <TextSpeech
              ref={messageMenuRef}
              positionFromTop={"0%"}
              backgroundColor={theme.color.white}
              style={{
                left: isRtl ? 100 : 'auto',
                right: !isRtl ? 100 : 'auto',
                borderRadius: 18,
                position: "absolute",
                padding: 0,
                bottom: 0,
                boxShadow: `0px 4px 20px #C3C0D3`,
              }}
            >
              <RepairMessages
                messages={repairPage.ZCOB_TENANTCONV_SUBFORM}
                repairPage={repairPage}
              />
            </TextSpeech>
          )
        }
      </div >
    </>
  );
};

export default inject(
  "tenantsStore",
  "userStore",
  "repairPagesStore"
)(observer(RepairPagesMessageContent));
